import { render, staticRenderFns } from "./sharing.vue?vue&type=template&id=c9842030&scoped=true&"
import script from "./sharing.vue?vue&type=script&lang=js&"
export * from "./sharing.vue?vue&type=script&lang=js&"
import style0 from "./sharing.vue?vue&type=style&index=0&id=c9842030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9842030",
  null
  
)

export default component.exports